import React, { Component, useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'
import { Route, Link, withRouter, BrowserRouter as Router, Switch } from 'react-router-dom'

import { getBusinessInfo, fetchBusinessInfo } from '../data/reducers/business'

import { NavigationContext } from './NavigationController'

import ProductListController from './ProductListController'
//import ProductDetailController from './ProductDetailController'

import FilterBar from '../views/FilterBar'

import moment from 'moment'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Container from '@material-ui/core/Container'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'

import TableData from '../views/TableData.js'

import ProductIcon from '@material-ui/icons/LocalOffer'
import CollectionIcon from '@material-ui/icons/Folder'
import DiscountIcon from '@material-ui/icons/MoneyOff'

const styles = theme => ({
  root: {
  },
  sectionTitle: {
    fontWeight: 700
  },
  filterTitleButton: {
    textTransform: 'none',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 400,
  },
  filterTitleButtonBold: {
    textTransform: 'none',
    fontSize: theme.typography.body2.fontSize,
    fontWeight: 700,
  },
  container: {
    paddingTop: theme.spacing(2)
  },
  cardView: {
    // Larger bottom to accomodate shadow
    paddingBottom: theme.spacing(8)
  },
  card: {
  },
  cardTitle: {
    fontWeight: 500,
  },
  counterText: {
    color: 'black',
    fontWeight: 500
  },
  tableView: {

  },
  calendarView: {
  },

})

const TableView = ({ theme, classes, records, lastFetched, isFetching, onEditContent, onClick }) => {
  const columns = [
    { key: 'images', label: 'Images', variant: 'image' },
    { key: 'name', label: 'Name', variant: 'name' },
    { key: 'status', label: 'Status' },
    { key: 'total_views', label: 'Views', type: 'number' },
  ]
  
  const getCellValue = (row, column) => {
    return row[column.key]
  }
  
  const getCellSecondaryValue = (row, column) => {
  }
  
  return (
    <TableData
      columns={columns}
      rows={records}
      getCellValue={getCellValue}
      getCellSecondaryValue={getCellSecondaryValue}
      onRowClick={(row) => onClick(row)}
      />
    )  
}

const CatalogController = ({ history, theme, classes, location }) => {

  const navigationContext = useContext(NavigationContext)

  const viewTypes = [
    { key: 'products', title: 'Products', icon: <ProductIcon color='inherit' />, component: TableView },
    { key: 'collections', title: 'Collections', icon: <CollectionIcon color='inherit' />, component: TableView },
    { key: 'discounts', title: 'Discounts', icon: <DiscountIcon color='inherit' />, component: TableView },
  ]
  
  const path = location.pathname
  let viewType = null
  if (path.startsWith("/catalog/")) {
    viewType = path.substring("/catalog/".length)
  }
  
  useEffect(() => {
    if (!viewType)
      history.push("/catalog/products")
  }, [viewType])
  
  return (
    <div>
      <FilterBar
        leftItems={(
          <>
            { viewTypes.map((item, index) =>
              <Box 
                className={item.key == viewType ? classes.menuItemSelected : classes.menuItemDefault}>
                <Button style={{ color: item.key == viewType ? 'black' : 'gray'}}
                  className={item.key == viewType ? classes.filterTitleButtonBold : classes.filterTitleButton}
                  component={Link}
                  to={`/catalog/${item.key}`}
                  >
                  { item.icon }
                  { item.title }
                </Button>
              </Box>
              )}
          </>
        )}
      />
      <div>
        <Switch>
          <Route exact path="/catalog/products" component={ProductListController}/>          
          {/*
          <Route path="/catalog/products/view/:productKey" render={ProductDetailController}/>
          */}
          <Route path="/catalog/products/:filterKey" render={ProductListController}/>          
        </Switch>              
      </div>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(CatalogController)
  )
)
